import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {ListItem} from 'material-ui/List';

import CircularProgress from 'material-ui/CircularProgress';
import moment from 'moment-timezone';
import AppModel from '../DataModel/AppModel';

import Avatar from 'material-ui/Avatar';
import Job from 'material-ui/svg-icons/action/restore';
import Warning from 'material-ui/svg-icons/alert/warning';

import JobAvatar from './JobAvatar';

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';

import {red500} from 'material-ui/styles/colors';

export default
@observer class JobListElement extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  formatPhaseList(job) {
    if(!job.running) return "";
    if(job.offline) return uiMsg('JLE_JOB_PHASE_UNKNOWN',"Job phase unknown (offline)");
    if(!job.activePhases) return uiMsg('JLE_NO_PHASE_INFO_FOR_JOB',"No phase info on job");
    return uiMsg('JLE_PROCESS_STAGE',"Process stage")+": "+ job.activePhases.join(", ");
  }

  formatJobLine(job) {
    return uiMsg('JLE_ROOM_NAMED',"Room: name",job.location_name)
    +", "+uiMsg('JLE_USER_STARTED_JOB',"X started job at Y",job.user_name,
      moment(job.start_time).tz(AppModel.time_zone).locale(AppModel.locale).format("LT"));
  }

  formatJobStartLine(job) {
    if(job.offline) return uiMsg('JLE_OFFLINE_LAST_STARTED',
      "Machine offline, last job started at TIME",
      moment(job.start_time).tz(AppModel.time_zone).locale(AppModel.locale).format("lll")
    )
    if(job.running) return uiMsg('JLE_JOB_STARTED_AND_TIME_LEFT',
      "Job started at X, Y left",
      moment(job.start_time).tz(AppModel.time_zone).locale(AppModel.locale).format("LT"),
      job.remain_string
    );
    if(job.end_time) return uiMsg('JLE_JOB_ENDED',"Job ended at X",
      moment(job.end_time).tz(AppModel.time_zone).locale(AppModel.locale).format("LT")
    );
  }

  gotoJobDetailPage(job) {
    var id_machine=job.id_machine;
    var starttime=job.start_time.getTime();
    var self = this;
    return function() {
      self.context.router.push(`/jobs/job/${id_machine}/${starttime}`);
    }
  }

  gotoJobGraph(job) {
    var id_machine=job.id_machine;
    var starttime=job.start_time.getTime();
    var self = this;
    return function() {
      self.context.router.push(`/jobs/job/${id_machine}/${starttime}/graph`);
    }
  }

  render() {
    var job = this.props.job;
    return (
      <Card>
        <CardHeader
          title={job.user_name}
          subtitle={this.formatJobStartLine(job)}
          avatar={ JobAvatar.pickRightJobAvatar(job) }
        />

      <CardTitle  title={uiMsg('JLE_ROOM_NAMED',"Room: N",job.location_name)}
                  subtitle={(<div>
                    {uiMsg('JLE_MACHINE_NAMED',"Machine: N",job.id_machine)}<br></br>
                    {this.formatPhaseList(job)}
                  </div>)} />
          {job.offline ? (
            <CardText>
            <div>
              <h2>
                {uiMsg('JLE_DISINFECTION_MACHINE_OFFLINE',"Disinfection machine offline.")}
              </h2>
              {uiMsg('JLE_NO_MEASUREMENTS_IN_5',"We have not received measurements from this job in 5 minutes.")}
            </div>
          </CardText>
          ) : null  }
          {job.h2o2_level && !job.offline > 0 ? (
          <CardText>
            <div>
              <h2 className="md-h2">
                H<sub>2</sub>O<sub>2</sub> {uiMsg('JLE_CONCENTRATION_LEVEL',"concentration level")}
              </h2>
              {uiMsg('JLE_CURRENT_PPM_LEVEL',"Current: X ppm ",job.h2o2_level)}
              <br></br>
              {job.running ?
                <span>
                  {uiMsg('JLE_AVG_PPM_LEVEL',"Avergage: X ppm ",job.h2o2_realtime_avg_value)}
                  <br></br>
                </span>
              : null }
              <br></br>
          <Warning color={red500} />{uiMsg('JLE_DO_NOT_ENTER_UNTIL',"Do not enter room until ")}
              H<sub>2</sub>O<sub>2</sub>{uiMsg('JLE_BELOW_SAFE_LEVEL'," concentration level is below safety limit.")}
            </div>
          </CardText>
          ) : null  }

         <CardActions>
           <FlatButton label={uiMsg('JLE_B_SEE_DETAILS',"See details")}
             onTouchTap={this.gotoJobDetailPage(job).bind(this)} />
           <FlatButton label={uiMsg('JLE_B_SEE_GRAPH',"See graph")}
             onTouchTap={this.gotoJobGraph(job).bind(this)} />
         </CardActions>
      </Card>
      )
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/JobListElement.jsx
 **/